import core, { View } from '@gin-betting/core';
import { createStructuredSelector } from 'reselect';

import { SportEventMetaKey } from 'app-constants';
import { useMemoSelector } from 'hooks';

const {
    entities: {
        selectors: { selectMatchCompetitorsValid, selectMatchMetaValueByName },
    },
} = core;

interface Input {
    sportEventId: string;
}

interface Output {
    competitorsValid: View.CompetitorsValid;
    isHomeServer: boolean;
    isAwayServer: boolean;
}

const useTeamsTitle = ({ sportEventId }: Input): Output => {
    const { competitorsValid, server } = useMemoSelector(makeSelectProps(), {
        matchId: sportEventId,
        metaName: SportEventMetaKey.Server,
    });

    const isHomeServer = server === 'home';
    const isAwayServer = server === 'away';

    return {
        competitorsValid,
        isHomeServer,
        isAwayServer,
    };
};

export default useTeamsTitle;

const makeSelectProps = () => {
    return createStructuredSelector({
        competitorsValid: selectMatchCompetitorsValid,
        server: selectMatchMetaValueByName,
    });
};
